import { render, staticRenderFns } from "./bottomTabConfigManagement.vue?vue&type=template&id=65f7aef8&scoped=true"
import script from "./bottomTabConfigManagement.vue?vue&type=script&lang=js"
export * from "./bottomTabConfigManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7aef8",
  null
  
)

export default component.exports